<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <client-control></client-control>
      <client-view></client-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientControl from "@/components/clients/clientControl";
import ClientView from "@/components/clients/clientView";

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
  components: {
    ClientControl,
    ClientView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
